import React from 'react';
import { observer } from 'mobx-react-lite';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import styles from './TransferLocationsListItem.module.css';
import { useRootStore } from '../../../../mobx/bridge';
import CustomConfirmAlert from '../CustomConfirmAlert/CustomConfirmAlert';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const TransferLocationsListItem = observer(function TransferLocationsListItem(props) {
  const { location } = props;

  const { commonStore, sendingEvents, settingsStore } = useRootStore();

  const { t } = useTranslation();

  const settings = settingsStore.getLoggedUserSettings;

  const transferLocation = () => {
    sendingEvents.socketWebChatEmitTransferConversation(
      location.CPLocationID,
      settings.SelectedChannel._id
    );
  };

  const confirmTransferLocation = () => {
    commonStore.setTransferLocationListOpen(false);

    confirmAlert({
      customUI: ({ onClose }) => (
        <CustomConfirmAlert
          title={t('Common.AreYouSure')}
          message={t('TransferLocationsList.ConfirmTransferConversationMessage', {
            locationName: location.LocationName,
          })}
          trueText={t('Common.Confirm')}
          trueEvent={transferLocation}
          falseText={t('Common.Close')}
          falseEvent={onClose}
        />
      ),
    });
  };

  return (
    <button onClick={confirmTransferLocation} type="button" className={styles.item}>
      {location.LocationName}
    </button>
  );
});
TransferLocationsListItem.whyDidYouRender = true;
TransferLocationsListItem.displayName = 'TransferLocationsListItem';

export default TransferLocationsListItem;
